import React from 'react'
import { layering } from '@mobi/component-library/Foundations'
import { BettingDrawerBase } from '@core/Components/BettingDrawer/Components/BettingDrawerBase'
import { ButtonBlock } from '@core/Components/Buttons/ButtonBlock'

export const ReviewSelectionsDrawer: React.FC<{
  open: boolean
  canReviewSelections: boolean
  onEditBet: () => void
  onReviewSelections: () => void
}> = ({ open, canReviewSelections, onEditBet, onReviewSelections }) => {
  return (
    <BettingDrawerBase
      isOpen={open}
      forcedZIndex={layering.overlayLow}
      secondaryButtonSlot={
        <ButtonBlock type='button' color='secondary' onClick={onEditBet}>
          Edit Bet
        </ButtonBlock>
      }
      primaryButtonSlot={
        <ButtonBlock
          type='button'
          color='primary'
          disabled={!canReviewSelections}
          onClick={onReviewSelections}
        >
          Review Selections
        </ButtonBlock>
      }
    />
  )
}
